import { schema } from 'normalizr'

import user from './user'

const reservationUser = new schema.Entity('reservationUsers', {
  user: user
})

export default reservationUser
